<template>
    <div class="app-container">
      <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'100px'" :search-btn-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" :tooltip-config="{ showAll: false, enterable: false }" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="24">
            <el-row :gutter="20">
              <!-- 客户订单号 -->
              <el-col :span="colSpan">
                <el-form-item :label="$t('InternalOrder.form.number')" prop="outerOrderNo">
                  <BjInput v-model="queryParams.outerOrderNo" style="height: 1px!important;" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
              <!-- 内部订单号 -->
              <el-col :span="colSpan">
                <el-form-item :label="$t('InternalOrder.form.Internal')" prop="innerOrderNo">
                  <BjInput v-model="queryParams.innerOrderNo" style="height: 1px!important;" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </template>

        <!-- tab选择页 -->
        <template v-slot:beforeSearchBtn>
          <el-col :span="24 - colSpan">
            <el-tabs :value="queryParamsTradeStatus" type="card" @tab-click="handleTabClick">
              <el-tab-pane key="one" :label="$t('businessLogisticsCompanyList.Not')" name="one" />
              <el-tab-pane key="two" :label="$t('businessLogisticsCompanyList.Imported')" name="two" />
            </el-tabs>
          </el-col>
        </template>

        <!-- 导出按钮 -->
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" @click="onExport">{{ $t('exportText') }}</el-button>
            <el-button type="danger" @click="onImport">{{ $t('BarcodeConfiguration.Import') }}</el-button>
          </el-col>
        </template>

        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span class="link" @click="$toBusinessThirdOrderView(scope.row.outerOrderNo, false, businessType)">{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'innerOrderNo'">
                  <span class="link" @click="$toBusinessOrderInternalView(scope.row.innerOrderNo, false, businessType)">{{ scope.row[col.prop] }}</span>
                  <BjCopyIcon :copy="scope.row[col.prop]" />
                </template>
                <template v-else-if="col.prop === 'logisticsStatus'">
                  <span>{{ scope.row[col.prop]==0 ? $t('businessLogisticsCompanyList.To') : scope.row[col.prop] == 1 ? $t('businessLogisticsCompanyList.be') : $t('businessLogisticsCompanyList.Uploaded') }}</span>
                </template>
                <template v-else-if="col.prop === 'importStatus'">
                  <span>{{ scope.row[col.prop]==0 ? $t('businessLogisticsCompanyList.Not') : $t('businessLogisticsCompanyList.Imported') }}</span>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <!-- 删除 -->
                <el-button type="text" class="delete-btn" @click="onDel(props.row)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 导入弹窗 -->
      <ExcelImportDialog ref="ExcelImport" @submit="handleQuery" />
    </div>
</template>

<script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi } from '@/api';
  import papa from 'papaparse';
  import ExcelImportDialog from './ExcelImportDialog.vue';
  import {
    ORDER_TRADE_TYPE_LIST,
    ORDER_BUSINESS_TYPE_LIST,
    ORDER_ACTION_TYPE_LIST,
    STATUS_YES_NUM,
    STATUS_HAVE_TRUE,
    ORDER_INTERNAL_ORDER_STATUS_LIST,
    ORDER_INTERNAL_PREEMPT_STATUS_LIST,
    ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
    ORDER_INTERNAL_SOURCE_STATUS_LIST,
    ORDER_INTERNAL_DELIVER_STATUS_LIST,
    ORDER_INTERNAL_RECEIVING_STATUS_LIST,
    ORDER_INTERNAL_STOCK_BACK_STATUS_LIST,
    ORDER_INTERNAL_HAND_UP_STATUS_LIST,
    ORDER_TAKING_DELIVERY_TYPE_LIST,
    ORDER_BUSINESS_TYPES,
    ORDER_DECRYPT_NAME,
  } from '@/utils/constants';
  export default {
    name: 'BusinessLogisticsImport',
    components: { ExcelImportDialog },
    mixins: [pageMiXin],
    props: {
      businessType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        selection: true,
        colSpan: 8,
        ORDER_TRADE_TYPE_LIST,
        ORDER_BUSINESS_TYPE_LIST,
        ORDER_ACTION_TYPE_LIST,
        STATUS_YES_NUM,
        STATUS_HAVE_TRUE,
        ORDER_INTERNAL_ORDER_STATUS_LIST,
        ORDER_INTERNAL_PREEMPT_STATUS_LIST,
        ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST,
        ORDER_INTERNAL_SOURCE_STATUS_LIST,
        ORDER_INTERNAL_DELIVER_STATUS_LIST,
        ORDER_INTERNAL_RECEIVING_STATUS_LIST,
        ORDER_INTERNAL_STOCK_BACK_STATUS_LIST,
        ORDER_INTERNAL_HAND_UP_STATUS_LIST,
        ORDER_TAKING_DELIVERY_TYPE_LIST,
        ORDER_BUSINESS_TYPES,
        ORDER_DECRYPT_NAME,

        // 查询参数 orderApi.getStatisticsLogisticsPage
        queryApi: orderApi.getStatisticsLogisticsPage,
        queryParams: {
          businessType: this.businessType,
          // Tab页类型
          importStatus: 0,
          outerOrderNo: null,
          innerOrderNo: null,
          queryParams_One: 'importPage'
        },
        labelsVersion: 13,
        queryParamsTradeStatus: 'one',
        // 未导入
        labelList1: [
          { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: 190 },
          { label: this.$t('InternalOrder.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: 180 },
          { label: this.$t('businessLogisticsCompanyList.number'), prop: 'logisticsNo', isCheck: true, disabled: false, width: 179 },
          { label: this.$t('businessLogisticsCompanyList.name'), prop: 'logisticsBusinessName', isCheck: true, disabled: false },
          { label: this.$t('businessLogisticsCompanyList.status'), prop: 'logisticsStatus', isCheck: true, disabled: false },
          { label: this.$t('businessLogisticsCompanyList.or'), prop: 'importStatus', isCheck: true, disabled: false },
        ],
        // 已导入
        labelList2: [
          { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: 190 },
          { label: this.$t('InternalOrder.form.Internal'), prop: 'innerOrderNo', isCheck: true, disabled: false, width: 180 },
          { label: this.$t('businessLogisticsCompanyList.number'), prop: 'logisticsNo', isCheck: true, disabled: false, width: 179 },
          { label: this.$t('businessLogisticsCompanyList.name'), prop: 'logisticsBusinessName', isCheck: true, disabled: false, width: 112 },
          { label: this.$t('businessLogisticsCompanyList.status'), prop: 'logisticsStatus', isCheck: true, disabled: false, width: 115 },
          { label: this.$t('businessLogisticsCompanyList.or'), prop: 'importStatus', isCheck: true, disabled: false, width: 109 },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ],
      };
    },
    computed: {
    labelList() {
      if (this.queryParamsTradeStatus === 'one') {
        return this.labelList1;
      } else {
        return this.labelList2;
      }
    }
  },
    methods: {
      // 导出按钮
      beforeExport(item) {
        return new Promise((reslove, reject) => {
          const newArr = this.SortableTable.checkList.length > 0 ? this.SortableTable.checkList.filter(item => item.isCheck) : this.labelList.filter(item => item.isCheck);
          const obj = {};
          Object.keys(item).forEach((kitem) => {
            newArr.forEach((jitem) => {
              // eslint-disable-next-line no-prototype-builtins
              if (!obj.hasOwnProperty(jitem.prop)) {
                obj[jitem.prop] = '';
              } else {
                if (jitem.prop == kitem) {
                  obj[jitem.prop] = item[jitem.prop];
                  reslove(obj);
                }
              }
            });
          });
        });
      },
      onExport() {
        const fileName = `Logistics Info`;
        if (!this.selectedRows.length) {
          this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
          return;
        }
        let csvData = [];
        this.selectedRows.forEach(async (item) => {
          await this.beforeExport(item).then(res => {
            csvData.push({
              InnerOrderNo: res.innerOrderNo,
              OuterOrderNo: res.outerOrderNo,
              LogisticsBusinessName: res.logisticsBusinessName,
              LogisticsNo: res.logisticsNo,
            });
          });
        });

        setTimeout(() => {
          if (!csvData.length) return;
          const csv = papa.unparse(csvData);
          const data = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          const csvURL = window.URL.createObjectURL(data);
          const download = document.createElement('a');
          download.href = csvURL;
          download.setAttribute('download', fileName);
          download.click();
          csvData = null;
        }, 1000);
      },

      // 导入按钮
      onImport() {
        this.$refs.ExcelImport.show();
      },
      // 删除按钮
      onDel(e) {
        orderApi.LogisticsPageDelOrder({ innerOrderNo: e.innerOrderNo }).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.deleteSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      },
      // tab页点击方法
      handleTabClick(tab, event) {
        // 根据页面tab框向后端返回0/1/2
        this.queryParams.importStatus = tab.name == 'one' ? Number(0) : Number(1);
        this.reFresh();
        setTimeout(() => {
          this.queryParamsTradeStatus = tab.name;
          this.handleColumn(this.labelList);
          this.$refs.BjPage.$refs.BjTable.clearChange();
        }, 100);
      },

      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParams.importStatus = 0;
        this.queryParamsTradeStatus = 'one';
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  </style>
